import { supabase } from './supabase'
import clientTokenService from './clientTokenService'

export const fetchReferences = async (sentenceId, messageId, conversationId) => {
  try {
    // Get token (Supabase JWT for authenticated users, client JWT for anonymous)
    let token = null
    const {
      data: { session },
    } = await supabase.auth.getSession()

    if (session?.access_token) {
      token = session.access_token
    } else {
      // Use client-side JWT for anonymous users
      token = clientTokenService.getCurrentToken()
    }

    // Call the Cloudflare Worker endpoint directly (not through the api client)
    const headers = {
      'Content-Type': 'application/json',
    }

    // Only add Authorization header if we have a token
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    const response = await fetch('/api/references', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        sentenceId,
        messageId,
        conversationId,
      }),
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch references: ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    console.error('Failed to fetch references:', error)
    throw error
  }
}
